import { render, staticRenderFns } from "./AdminNews.vue?vue&type=template&id=76682b02&scoped=true&"
import script from "./AdminNews.vue?vue&type=script&lang=js&"
export * from "./AdminNews.vue?vue&type=script&lang=js&"
import style0 from "./AdminNews.vue?vue&type=style&index=0&id=76682b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76682b02",
  null
  
)

export default component.exports